import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vueResource from 'vue-resource';
import jquery from 'jquery';
import vueMoment from 'vue-moment';
import moment from 'moment-timezone';
import CKEditor from '@ckeditor/ckeditor5-vue';
import VueTheMask from 'vue-the-mask';
import VueCookies from 'vue-cookies';
import EventBus from 'vue-bus-ts';
import IdleVue from 'idle-vue';
import VueNativeSock from 'vue-native-websocket';
import VueEllipseProgress from 'vue-ellipse-progress';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.snow.css'
import QuillEmoji from 'quill-emoji';
import 'quill-emoji/dist/quill-emoji.css';
import '@/modules/svg-components';
import '@/modules/tooltip';
import '@/modules/apexcharts';
import 'leaflet/dist/leaflet.css';

Vue.prototype.$ = jquery;
Vue.prototype.navigator = navigator;
Vue.prototype.window = window;

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

Vue.config.productionTip = false;

Vue.use(VueEllipseProgress);
Vue.use(VueTheMask);
Vue.use(vueResource);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
require('moment/locale/pt-br');
Vue.use(vueMoment, {
  moment
});
Vue.use(CKEditor);
Vue.use(VueCookies);

Vue.use(EventBus);
var bus = new EventBus.Bus();

Vue.use(IdleVue, {
  eventEmitter: new Vue(),
  store,
  idleTime: 600000, // 10min
  startAtIdle: false
});
//The above code does two things:
//Add two hooks onIdle and onActive to all Vue objects
//Add a computed value isAppIdle to all Vue objects
Vue.use(VueNativeSock, `${process.env.VUE_APP_WEBSOCKET_URL!}`, {
  store: store,
  format: 'json',
  connectManually: true,
});

(Vue as any).router = router;
(Vue as any).http.options.root = process.env.VUE_APP_ROOT_API;

Vue.http.interceptors.push((request: any, next: any) => {
  if(request.url !== undefined){
    const removeAuthHeaders = request.url.includes('X-Amz-Algorithm');
    if (removeAuthHeaders){
      request.headers.delete('Authorization')
    }
  }
});

Vue.use(require('@websanova/vue-auth'), {
  auth: {
    request(req: any, token: any) {
      if (req.url === (this as any).options.refreshData.url) {
        req.body = { access_token: token, refresh_token: (this as any).token((this as any).options.refreshTokenName)};
      } else
        (this as any).options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token });
    },
    response(res: any) {
      if (res.body.token && typeof res.body.token === 'string') {
        return res.body.token;
      } else if (res.body.token && typeof res.body.token === 'object') {
        (this as any).token((this as any).options.refreshTokenName, res.body.token.refresh_token);
        return res.body.token.access_token;
      }
    },
  },
  http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'profile',
  tokenDefaultName: 'token',
  tokenStore: ['localStorage', 'cookie'],
  authRedirect: '/',
  loginData: { url: 'auth/login', method: 'POST', redirect: null, fetchUser: true },
  fetchData: { url: 'auth/user', method: 'GET', enabled: true },
  parseUserData: (data: any) => {
    return data;
  },
  refreshData: { enabled: true, url: 'auth/refresh-token', method: 'PUT', interval: 15 },
  refreshTokenName: 'refreshToken',
  forbiddenRedirect: '/dashboard'
});

Vue.use(VueQuillEditor)
Vue.use(QuillEmoji)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  bus,
  render: h => h(App)
}).$mount('#app');
